var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircledCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_5603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82232 6.7672L5.00065 5.58886L6.17898 6.7672L6.76815 6.17803L5.58982 4.9997L6.76815 3.82136L6.17898 3.2322L5.00065 4.41053L3.82232 3.2322L3.23315 3.82136L4.41148 4.9997L3.23315 6.17803L3.82232 6.7672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 9.16634C7.29815 9.16634 9.16732 7.29717 9.16732 4.99967C9.16732 2.70217 7.29815 0.833008 5.00065 0.833008C2.70315 0.833008 0.833984 2.70217 0.833984 4.99967C0.833984 7.29717 2.70315 9.16634 5.00065 9.16634ZM5.00065 1.66634C6.83857 1.66634 8.33398 3.16176 8.33398 4.99967C8.33398 6.83759 6.83857 8.33301 5.00065 8.33301C3.16273 8.33301 1.66732 6.83759 1.66732 4.99967C1.66732 3.16176 3.16273 1.66634 5.00065 1.66634Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_5603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircledCross);
export default __webpack_public_path__ + "static/media/icon-circled-cross.1d024d245b6cd518255b4482d9105d96.svg";
export { ForwardRef as ReactComponent };